/**
 * Privacy Policy page — content sourced from privacy_policy.md
 */

import type React from 'react';

import { MarkdownDocPage } from '../../components/MarkdownDoc/MarkdownDoc';
import privacyPolicyMarkdown from '../../data/privacy_policy.md?raw';

export const Privacy: React.FC = () => (
  <MarkdownDocPage
    markdown={privacyPolicyMarkdown}
    pageTitle="Privacy Policy"
    path="/privacy"
  />
);
